import React, { Component } from 'react';
import classes from './Loading.module.css'
import Toolbar from '../Toolbar/Toolbar'

import Footer from '../Footer/Footer'
import Spinner from 'react-bootstrap/Spinner'

class Trader extends Component {

  state = {


  };


  

  componentDidMount() {


  }



  render() {



      return (


        <div className={classes.Trader}>


          <Toolbar></Toolbar>

          <div className={classes.change}>
            
          <div className={classes.def}>
            Loading ...
          </div>
            
          <Spinner animation="border" variant="success" />


          </div>
          <Footer></Footer>

        </div>

      )


  }
}
export default Trader;
